/** Lokal cache för AI-tolkade sökningar, så att liknande sökningar inte kostar kvot. */

const KEY = "sellavo:ai-sok";
const TTL = 24 * 60 * 60 * 1000;
const MAX = 40;

export type CachedAiSearch = {
  filters: { q?: string; kategori?: string; maxPris?: number; minPris?: number };
  explanation: string;
  at: number;
};

type Store = Record<string, CachedAiSearch>;

export function normalizeQuery(query: string): string {
  return query
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .split(/\s+/)
    .filter(Boolean)
    .sort()
    .join(" ");
}

function read(): Store {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? (parsed as Store) : {};
  } catch {
    return {};
  }
}

export function getCachedAiSearch(query: string): CachedAiSearch | null {
  const hit = read()[normalizeQuery(query)];
  if (!hit || Date.now() - hit.at > TTL) return null;
  return hit;
}

export function cacheAiSearch(query: string, value: Omit<CachedAiSearch, "at">) {
  if (typeof window === "undefined") return;
  const store = read();
  store[normalizeQuery(query)] = { ...value, at: Date.now() };
  const entries = Object.entries(store)
    .sort((a, b) => b[1].at - a[1].at)
    .slice(0, MAX);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(entries)));
  } catch {
    /* ignorera full lagring */
  }
}
